import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { icon } from "../../../../../../config";
import { EXPRESSION_LABELS } from "../../../constants/expressionBuilder.constants";
import "../../../styles/ExpressionBuilder.css";

/**
 * Component for rendering group header with title and delete button
 * @param {Object} group - Group configuration
 * @param {Function} onRemove - Remove handler
 * @param {boolean} isRoot - Whether this is the root group
 * @returns {JSX.Element} Group header component
 * @author Abhishek Dhillon
 * @parent GroupComponent
 */
const GroupHeader = ({ group, onRemove, isRoot = false }) => {
  /**
   * Gets the group title based on whether it's root or nested
   * @returns {string} Group title
   * @author Abhishek Dhillon
   */
  const getGroupTitle = () => {
    return isRoot ? EXPRESSION_LABELS.ROOT_GROUP : `${EXPRESSION_LABELS.GROUP}`;
  };

  return (
    <div className='expression-builder-group-header'>
      <h6 className='expression-builder-group-title'>
        {""}
        <span className='expression-builder-ms-2'>{getGroupTitle()}</span>
      </h6>
      {!isRoot && (
        <Button
          onClick={onRemove}
          icon='trash'
          fillMode='flat'
          themeColor='error'
          title={EXPRESSION_LABELS.DELETE_GROUP}
          id={`delete-group-${group?.id}`}
        />
      )}
    </div>
  );
};

export default GroupHeader;
